import Vue from 'vue'
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib'
import VuetifyToast from 'vuetify-toast-snackbar'
import cs from 'vuetify/es5/locale/cs'
import '@mdi/font/css/materialdesignicons.css'
  
Vue.use(Vuetify, {
    components: {
        VSnackbar,
        VBtn,
        VIcon,
    },
});

Vue.use(VuetifyToast, {
    x: 'center',
    y: 'bottom',
    timeout: 5000,
    queueable: false,
    showClose: true,
    closeIcon: 'mdi-close',
    closeText: cs.close,
});

export default new Vuetify({
    lang: {
        locales: {
            cs,
        },
        current: 'cs',
    },
    icons: {
        iconfont: 'mdi',
    },
    breakpoint: {
        thresholds: {
          xs: 720,
          sm: 1240,
          md: 1920,
          lg: 5000,
          xl: 8000,
        }, 
    },   
});
